<div>
  <div class="mapfre-fs-xxxl dark mapfre-mt-l title">
    {{ "SERVICES.WHAT_SERVICE_NEED" | translate }}
  </div>
  <div class="mapfre-fs-s gray1 mapfre-mt-m">
    {{ state.codGuia ? ("SERVICES.POLICY_DESCRIPTION" | translate) : ("SERVICES.POLICY_DESCRIPTION_UNIDENTIFIED" | translate) }}
  </div>

  <div *ngFor="let ele of newCardArray">
    <div class="flex jc-s images-wrapper-web mapfre-mt-l mapfre-hide-mobile mapfre-hide-tablet">
      <div *ngFor="let e of ele" class="flex fd-col ai-c" (click)="navTo(e?.url)">
        <img alt=" " [src]="e?.imagenTarjetaEscritorio" />
        <span class="mapfre-mt-m mapfre-fs-m dark">{{e.tituloTarjeta | translate}}</span>
      </div>
    </div>
  </div>

  <div *ngFor="let ele of newCardArray">
    <div class="flex mapfre-mt-l  mapfre-hide-desktop images-wrapper" [ngClass]="{
      'jc-c ':ele.length === 2,
      'jc-s mapfre-ml-xs ':ele.length === 1
    }">
      <div *ngFor="let e of ele" class="ai-c flex fd-col" (click)="navTo(e?.url)">
        <img alt=" " [src]="e?.imagenTarjetaMovil" />
        <span class="mapfre-mt-s mapfre-fs-xs dark">{{
          e?.tituloTarjeta | translate
          }}</span>
      </div>
    </div>
  </div>
</div>